import styled from "styled-components";

const desktop = 920;

export const CoursesContainer = styled.div`
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
  }

  p {
    width: 70%;
    margin-bottom: 0;
  }

  h3 {
    margin: 0.7em 0;
    text-transform: uppercase;
    font-size: 26px;
    color: #aa0000;
    text-align: center;
  }

  @media (min-width: ${desktop}px) {
    img {
      width: 70%;
      margin: 20px auto;
    }
  }
`;

export const TheatersSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1em 0 2em;

  p {
    width: 100%;
  }

  img {
    width: 100%;
  }

  h4 {
    font-size: 23px;
    margin: 0;
    color: black;
  }
`;

export const City = styled.h3`
  margin: 20px 0;
  text-transform: uppercase;
  font-size: 26px;
  color: #aa0000;
  text-align: center;
`;

export const InCourses = styled.div`
  width: 80%;
  margin: 3em auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 2em;

  img {
    width: 50%;
    margin: 0 auto;
    border-radius: 10px;
  }

  p {
    width: 70%;
  }
`;

export const ParagraphPaternCourse = styled.p`
  margin: 0 auto;
  width: 100%;
  text-align: justify;
  color: #4c4c4c;
  font-size: 20px;
  line-height: 1em;
`;
